import "./dialog.css";

class DialogElement extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const slottedContent = this.querySelector(
            "template[slot='content']",
        ) as HTMLTemplateElement | null;
        const slottedTrigger = this.querySelector(
            "template[slot='trigger']",
        ) as HTMLTemplateElement | null;

        const open = this.hasAttribute("open");

        const dialog = document.createElement("dialog");
        let contentRendered = false;

        const renderContent = () => {
            if (contentRendered) return;
            contentRendered = true;
            if (slottedContent) {
                dialog.appendChild(slottedContent.content.cloneNode(true));
            }
        };

        const openDialog = () => {
            renderContent();
            dialog.showModal();
        };

        const trigger = document.createElement("div");
        trigger.className = "bd-dialog-trigger";
        if (slottedTrigger) {
            trigger.addEventListener("click", openDialog);
            trigger.innerHTML = slottedTrigger.innerHTML;
            this.append(trigger);
        }

        this.appendChild(dialog);
        dialog.addEventListener("click", (e) => {
            const closer = (e.target as HTMLElement).closest(
                ".bd-dialog-closer",
            );
            if (closer) {
                dialog.close();
            }
        });

        if (open) {
            openDialog();
        }
    }
}

customElements.define("bd-dialog", DialogElement);